import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};

import { DeviceUUID } from "device-uuid"

const state = {
  isLoadingTable: false,
  isloadingConfiguration: false,
  isloadingClient: false,
  isloadingOrder: false,
  // client: {},
  client: {},
  order: {},
  leader: null,
  leaderusers: [],
  old_order: {},
  configuration: null,
  player_id: null,
  payement_config: null,
  error_message: "",
  isloadingCheckingLeader: false,
  checkList: []

};

const getters = {
  client: state => state.client,
  isloadingCheckingLeader: state => state.isloadingCheckingLeader,
  leader: state => state.leader,
  leaderusers: state => state.leaderusers,
  configuration: state => state.configuration,
  player_id: state => state.player_id,
  isLoadingTable: state => state.isLoadingTable,
  isloadingOrder: state => state.isloadingOrder,
  isloadingClient: state => state.isloadingClient,
  order: state => state.order,
  old_order: state => state.old_order,
  payement_config: state => state.payement_config,
  error_message: state => state.error_message,
  checkList: state => state.checkList,
};

const mutations = {
  setPlayerId(state, payload) {
    state.player_id = payload
  },
  updateOrderError(state, payload) {

  },
  getConfigurationSuccess(state, payload) {
    state.isloadingConfiguration = false;
    state.configuration = payload.configuration;
  },
  addClientSuccess(state, payload) {
    state.isloadingClient = false;
    console.log({ payload })
    state.client = payload;
  },
  checkTableSuccess(state, payload) {
    console.log({ payload })
    state.isLoadingTable = false;
    state.order = payload;
    state.old_order = payload;
  },


  setPayementSuccess(state, payload) {
    state.isloadingOrder = false;
    state.payement_config = payload;
  },
  createOrderSuccess(state, payload) {
    state.isloadingOrder = false;
    state.order = payload;
  },
  createOrderError(state, payload) {
    state.isloadingOrder = false;
    state.error_message = payload.message;
  },
  updateOrderSuccess(state, payload) {
    state.isloadingOrder = false;
    // state.order = payload;
  },
  getOrderbyRefSuccess(state, payload) {
    state.isloadingOrder = false;
    state.order = payload;
  },

  startTable(state, payload) {
    state.isLoadingTable = true;
  },
  checkTableError(state, payload) {
    state.isLoadingTable = false;
  },
  getConfigurationError(state, error) {
    state.isloadingConfiguration = false;
    state.errorRestau = error;
  },
  addClientError(state, error) {
    state.isloadingClient = false;
    state.errorRestau = error;
  },
  startConfiguration(state, error) {
    state.isloadingConfiguration = true;
  },
  startClient(state, error) {
    state.isloadingClient = true;
  },
  startChekingLeader(state, payload) {
    state.isloadingCheckingLeader = true;
  },
  setLeader(state, payload) {
    state.leader = payload.data;
    state.leaderusers = payload.users;
    state.isloadingCheckingLeader = false;
  },
  startCreateOrder(state, error) {
    state.isloadingOrder = true;
  },
  startUpdateOrder(state, error) {
    state.isloadingOrder = true;
  },
  startOrderbyRef(state, error) {
    state.isloadingOrder = true;
  },
  SetCheckListGn2(state, payload) {
    console.log({payload})
    state.checkList = payload;
    state.order = payload.items;
  },
};

const actions = {
  getConfiguration({ commit }, payload) {
    // token = localStorage.getItem("accessToken")
    commit("startConfiguration", {});
    axios
      .get(`${apiPath}/retaurants/${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getConfigurationSuccess", {
            configuration: res.data.web
          });
        } else {
          commit("getConfigurationError", "error:getConfiguration");
        }
      });
  },
  async addClient({ commit }, payload) {
    commit("startClient", {});
    return axios
      .post(`${apiPath1}/client/createWithEmail`, payload.client, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addClientSuccess", res.data);
        } else {
          commit("addClientError", "error:addClient");
        }
        return res;
      });
  },
  async CheckLeader({ commit }, payload) {
    commit("startChekingLeader", {});

    return await axios
      .post(`${apiPath1}/check/leader`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setLeader", { data: res.data, users: res.users });
        }
        return res;
      });
  },
  async AcceptLeader({ commit }, payload) {
    commit("startChekingLeader", {});

    return await axios
      .post(`${apiPath1}/accept/leader`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setLeader", { data: res.data, users: res.users });
        }
        return res;
      });


  },

  async checkClient({ commit }, payload) {
    commit("startClient", {});

    var deviceKey = localStorage.getItem("deviceKey")
    if (!deviceKey) {
      // deviceKey = du.hashMD5(dua.join(':'));
      deviceKey = new DeviceUUID().get();
      localStorage.setItem("deviceKey", deviceKey)
    }

    // alert(deviceKey)

    //du.hashMD5(dua.join(':'));



    if (userId) {
      commit("setPlayerId", userId);
    }
    // axios
    //   .post(`${apiPath1}/client/create`, {
    //     key: userId,
    //     deviceKey:deviceKey,
    //     socketId:payload.socketId,
    //     restaurant: payload.restaurant,
    //   }, config)
    //   .then(r => r.data)
    //   .then(res => {
    //     if (res.ok) {
    //       commit("addClientSuccess", res.data);
    //     } else {
    //       commit("addClientError", "error:addClient");
    //     }
    //     return res;
    //   });


  },

  commitCheckTable({ commit }, payload) {




    commit("checkTableSuccess", payload.data[payload.data.length - 1]);

  },
  checkTable({ commit }, payload) {
    commit("startTable", {});
    return axios
      .post(`${apiPath1}/check_table`, payload, config)
      .then(r => r.data)
      .then(res => {
        console.log(res);
        if (res.ok && res.data) {
          commit("checkTableSuccess", res.data[0]);
        } else {
          commit("checkTableError", "error:addClient");
        }
        return res;
      });
  },
  downloadFile({ commit }, payload) {
    var req = new XMLHttpRequest();
    // let payload = {
    //   rvcRef:this.order[0].header.rvcRef,
    //   checkRef:this.order[0].header.checkRef,
    //   restaurant:this.$route.params.restaurant
    // }
    let urlToSend = `${apiPath1}/download/bill?checkRef=${payload.checkRef}&rvcRef=${payload.rvcRef}&restaurant=${payload.restaurant}`
    window.open(urlToSend, "_blank")

  },
  generateBill({ commit }, payload) {
    return axios
      .get(`${apiPath1}/download/bill?CheckNum=${payload.CheckNum}&CheckSeq=${payload.CheckSeq}&ref=${payload.ref}`, config)

  },

  getOperaReservation({ commit }, payload) {
    return axios
      .get(`${apiPath1}/opera/get/reservation/${payload}`, config)

  },


  sendBill({ commit }, payload) {

    return axios
      .get(`${apiPath1}/send/bill?CheckNum=${payload.CheckNum}&CheckSeq=${payload.CheckSeq}&ref=${payload.ref}`, config)
      .then(r => r.data)
      .then(res => {
        console.log(res);

        return res;
      });



  },
  async getCheckListGn2({ commit }, payload) {

    try {
      let tokenn = localStorage.getItem('accessTokenGen2')

      console.log({ payload })
      console.log({
        params: {
          resto_slug: payload.resto_slug,
          rvcRef: payload.rvcRef,
          restaurant: payload.restaurant,
          menu: payload.menu
        }
      })
      return await axios.get(`${apiPath}/gen2/checksList`, {
        params: {
          resto_slug: payload.resto_slug,
          rvcRef: payload.rvcRef,
          // restoSlug: payload.slug,
          restaurant: payload.restaurant,
          tableName: payload.tableName,
          menu: payload.menu


          // orgShortName : payload.orgShortName,
          // locRef: payload.locRef
        },
        headers: {
          Authorization: `Bearer ${tokenn}`
        }
      }).then((r) => {
        console.log({ menus: r.data })
        commit("SetCheckListGn2", r.data)

        return r.data
      });
    } catch (err) {
      this.error = 'Error fetching checks';
      console.error('Error fetching checks:', err);
    }
  },
  async postCheckGen2({ commit }, payload) {

    try {
      console.log(payload.dataUpdateGen2)
      return await axios.post(`${apiPath}/gen2/check`, payload
        //    {
        //   menu: payload.dataGen2.menu,
        //   restaurant: payload.dataGen2.restaurant,
        //   rvcRef: payload.dataGen2.rvcRef,
        //   resto_slug: payload.dataGen2.resto_slug,
        // }
      ).then((r) => {
        console.log({ check: r.data })

        return r.data
      });
    } catch (err) {
      this.error = 'Error posting check';
      console.error('Error posting check:', err);
    }
  },
  async updateCheckGen2({ commit }, payload) {

    try {
      console.log(payload.dataGen2)
      return await axios.post(`${apiPath}/gen2/check/round`, payload
        //    {
        //   menu: payload.dataGen2.menu,
        //   restaurant: payload.dataGen2.restaurant,
        //   rvcRef: payload.dataGen2.rvcRef,
        //   resto_slug: payload.dataGen2.resto_slug,
        // }
      ).then((r) => {
        console.log({ check: r.data })

        return r.data
      });
    } catch (err) {
      this.error = 'Error updating check';
      console.error('Error updating check:', err);
    }
  },
  createOrder({ commit }, payload) {
    commit("startCreateOrder", {});

    return axios({
      method: "post",
      url: `${apiPath1}/create/order/ex2`,
      timeout: 1000 * 5, // Wait for 5 seconds
      headers: {
        "Content-Type": "application/json"
      },
      data: payload.data,
      ...config
    })
      .then(res => {
        console.log(res)
        if (res.data.ok === false) {
          commit("createOrderError", res.data);

        } else {
          commit("createOrderSuccess", res.data);
        }
        payload.callback(res.data);
      }).catch(error => {
        console.log("errorerrorerrorerror")
        console.log(error);
        commit("createOrderError", error);
        payload.callback({ ok: false });
        return { ok: false }
      });
    return axios
      .post(`${apiPath1}/create/order/ex2`, payload.data, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok === false) {
          commit("createOrderError", "error:addClient");

        } else {
          commit("createOrderSuccess", res);
        }
        payload.callback(res);
      });
  },
  updateOrder({ commit }, payload) {
    commit("startUpdateOrder", {});
    return axios
      .post(`${apiPath}/update/order/ex2`, { ...payload.data }, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("updateOrderSuccess", res.data);
        } else {
          commit("updateOrderError", "error:addClient");
        }
        return res
      });
  },
  async rateItem({ commit }, payload) {

    return axios
      .post(`${apiPath}/rate-item/${payload.restaurant}/${payload.menu}`, payload, config)
      .then(r => r.data)
      .then(res => {
        console.log(payload)
        return res;
      });

  },
  async rateserviceambiance({ commit }, payload) {

    return axios
      .post(`${apiPath}/rate-service-ambiance`, payload)
      .then(r => r.data)
      .then(res => {
        // console.log(payload)
        return res;
      });

  },
  getOrderbyRef({ commit }, payload) {
    // commit("startOrderbyRef",{});
    return axios
      .post(`${apiPath1}/get/order/ref`, { ref: payload.ref }, config)
      .then(r => r.data)
      .then(res => {
        if (res.order) {
          commit("getOrderbyRefSuccess", res.order);
          payload.callback(res.order);

        } else {
          commit("getOrderbyRefError", "error:addClient");
        }
      });
  },
  generatePaymentData({ commit }, payload) {
    // commit("startUpdateOrder",{});
    return axios
      .post(`${apiPath1}/generate/payment/data`, payload.data, config)
      .then(r => r.data)
      .then(res => {
        if (res.TPE) {

          commit("setPayementSuccess", res);
          payload.callback({ ok: true })
        } else {
          commit("updateOrderError", "error:addClient");
        }
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
